import { styled } from '@mui/material';
import IcCloseLargeThin from '@kep/kcds-icons/IcCloseLargeThin';

import { IconButtonGhost } from '../IconButtonGhost';
import { modalHeaderClasses } from './theme';

import type { ModalHeaderProps } from './types';

const ModalHeader = (props: ModalHeaderProps) => {
  const { description, hideCloseButton, loading, onClose, title, ...others } = props;

  const disableCloseButton = loading;

  return (
    <ModalHeaderRoot {...others}>
      <ModalHeaderContent>
        {title && <ModalHeaderTitle>{title}</ModalHeaderTitle>}
        {description && <ModalHeaderDescription>{description}</ModalHeaderDescription>}
      </ModalHeaderContent>
      {onClose && !hideCloseButton && (
        <ModalHeaderCloseIcon
          size="xl"
          disabled={disableCloseButton}
          onClick={event => onClose(event, 'backdropClick')}
        >
          <IcCloseLargeThin />
        </ModalHeaderCloseIcon>
      )}
    </ModalHeaderRoot>
  );
};

export default ModalHeader;

const ModalHeaderRoot = styled('div', {
  target: modalHeaderClasses.root,
})`
  display: flex;
  padding: 32px 0 24px 0;
`;

const ModalHeaderContent = styled('div', {
  target: modalHeaderClasses.content,
})`
  flex: 1 0 0;
`;

const ModalHeaderTitle = styled('h2', {
  target: modalHeaderClasses.title,
})`
  color: #131619;
  font-size: 20px;
  font-weight: 600;
  line-height: 30px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
`;

const ModalHeaderDescription = styled('div', {
  target: modalHeaderClasses.description,
})`
  color: #676f7d;
  font-size: 13px;
  font-weight: 400;
  line-height: 19.5px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  white-space: pre-line;
`;

const ModalHeaderCloseIcon = styled(IconButtonGhost, {
  target: modalHeaderClasses.closeIcon,
})`
  margin-top: -14px;
  margin-right: -14px;
`;
